import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  SquaresFour,
  UsersThree,
  CalendarBlank,
  MapTrifold,
  SignOut,
  ShieldCheck,
} from "@phosphor-icons/react";

const baseLinks = [
  { to: "/", label: "Dashboard", icon: SquaresFour, end: true, id: "nav-dashboard" },
  { to: "/workers", label: "People", icon: UsersThree, id: "nav-workers" },
  { to: "/schedule", label: "Schedule", icon: CalendarBlank, id: "nav-schedule" },
  { to: "/routing", label: "Routing", icon: MapTrifold, id: "nav-routing" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";
  const links = isAdmin
    ? [...baseLinks, { to: "/users", label: "Users", icon: ShieldCheck, id: "nav-users" }]
    : baseLinks;

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-[1000] bg-white border-b-2 border-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 bg-blue-500 border-2 border-black rounded-lg brutal-shadow-sm flex items-center justify-center">
              <MapTrifold weight="bold" className="text-white" size={20} />
            </div>
            <span className="font-display font-bold text-xl tracking-tight">ShiftRoute</span>
          </div>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={l.id}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-4 py-2 rounded-lg font-bold text-sm border-2 transition-all ${
                    isActive
                      ? "bg-yellow-200 border-black brutal-shadow-sm"
                      : "border-transparent hover:border-black hover:bg-slate-50"
                  }`
                }
              >
                <l.icon weight="bold" size={18} />
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex flex-col items-end leading-tight">
              <span className="font-bold text-sm">{user?.name}</span>
              <span className="text-xs uppercase font-bold tracking-wider text-blue-600">
                {user?.role}
              </span>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              className="bg-red-300 border-2 border-black rounded-lg p-2 brutal-shadow-sm hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-all"
            >
              <SignOut weight="bold" size={18} />
            </button>
          </div>
        </div>
        {/* mobile nav */}
        <nav className="md:hidden flex items-center justify-around border-t-2 border-black bg-white">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`m-${l.id}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2 px-3 text-xs font-bold flex-1 ${
                  isActive ? "bg-yellow-200" : ""
                }`
              }
            >
              <l.icon weight="bold" size={20} />
              {l.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
